import { useEffect } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppDispatch, useAppSelector } from '../../../../stores/redux-store';
import { applicationParameters } from '../../../../utilities/application-parameters';
import { fetchPaymentDetails } from '../../services/payments-services';

export const usePaymentDetails = () => {
  const dispatch = useAppDispatch();

  const { data: paymentDetails, error: paymentDetailsError } = useAppSelector(
    (state) => state.paymentDetails,
    shallowEqual
  );
  const paymentRequestId = applicationParameters.get('paymentRequestId') as string;

  useEffect(() => {
    if (!paymentDetails && !paymentDetailsError) {
      dispatch(fetchPaymentDetails(paymentRequestId));
    }
  }, [dispatch, paymentDetails, paymentRequestId, paymentDetailsError]);

  return paymentDetails;
};
